import { formatHijriDate, useI18n } from '@bassitai/shared-i18n';
import React from 'react';

export default function LocaleToggle() {
  const { isRtl, locale, t, toggleLocale } = useI18n();
  const nextLocaleLabel = locale === 'en' ? 'العربية' : 'English';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '12px',
        padding: '12px 16px',
        borderBottom: '1px solid var(--color-border)',
      }}
    >
      <button
        type="button"
        onClick={() => toggleLocale()}
        aria-label={t('common.switchLanguage')}
        style={{
          border: '1px solid var(--color-primary)',
          borderRadius: 'var(--border-radius)',
          background: 'var(--color-bg)',
          color: 'var(--color-primary)',
          padding: '6px 10px',
          cursor: 'pointer',
          fontFamily: 'var(--font-family)',
        }}
      >
        {t('common.language')}: {nextLocaleLabel}
      </button>
      <span style={{ fontSize: '12px', color: 'var(--color-text)' }}>
        {isRtl ? t('common.directionRtl') : t('common.directionLtr')} · {t('common.todayHijri')}:{' '}
        {formatHijriDate(new Date(), locale)}
      </span>
    </div>
  );
}
